export const MarkerTemplatesConstants = {
  POPULATE_MARKERTEMPLATES: 'POPULATE_MARKERTEMPLATES',

  GET_WORLD_TEMPLATES_REQUEST: 'GET_WORLD_MARKER_TEMPLATES_REQUEST',
  GET_WORLD_TEMPLATES_SUCCESS: 'GET_WORLD_MARKER_TEMPLATES_SUCCESS',
  GET_WORLD_TEMPLATES_FAILURE: 'GET_WORLD_MARKER_TEMPLATES_FAILURE',

  GET_TEMPLATE_REQUEST: 'GET_MARKER_TEMPLATE_REQUEST',
  GET_TEMPLATE_SUCCESS: 'GET_MARKER_TEMPLATE_SUCCESS',
  GET_TEMPLATE_FAILURE: 'GET_MARKER_TEMPLATE_FAILURE',

  UPDATE_TEMPLATE_REQUEST: 'UPDATE_MARKER_TEMPLATE_REQUEST',
  UPDATE_TEMPLATE_SUCCESS: 'UPDATE_MARKER_TEMPLATE_SUCCESS',
  UPDATE_TEMPLATE_FAILURE: 'UPDATE_MARKER_TEMPLATE_FAILURE',

  CREATE_TEMPLATE_REQUEST: 'CREATE_MARKER_TEMPLATE_REQUEST',
  CREATE_TEMPLATE_SUCCESS: 'CREATE_MARKER_TEMPLATE_SUCCESS',
  CREATE_TEMPLATE_FAILURE: 'CREATE_MARKER_TEMPLATE_FAILURE',

  DELETE_TEMPLATE_REQUEST: 'DELETE_MARKER_TEMPLATE_REQUEST',
  DELETE_TEMPLATE_SUCCESS: 'DELETE_MARKER_TEMPLATE_SUCCESS',
  DELETE_TEMPLATE_FAILURE: 'DELETE_MARKER_TEMPLATE_FAILURE',
};
